const UNDEFINED_ICON_NAME = 'folder-backup-clr';
const ARCHIVE_TYPE_ICON_NAME_MAP = new Map([
  ['NOTARIZED', 'notarized-backup-clr'],
  ['BACKUP', 'folder-backup-clr'],
  ['A3_BACKUP', 'folder-backup-clr'],
  ['ARPF_BACKUP', 'folder-backup-clr'],
  ['DISK_BACKUP', 'disk-backup-clr'],
  ['A3_DISK_BACKUP', 'disk-backup-clr'],
  ['ENTIRE_PC', 'pc-clr'],
  ['A3_ENTIRE_PC_BACKUP', 'pc-clr'],
  ['SYNC', 'sync-clr'],
  ['ARCHIVING', 'archive-section-clr'],
  ['FILE', 'folder-backup-clr'],
  ['IMAGE', 'disk-backup-clr'],
  ['EXCHANGE', 'db-clr'],
  ['SQL', 'server-clr'],
  ['SYS_STATE', 'system-state-clr'],
  ['EXCHANGE_DOC', 'mailbox-clr'],
  ['EXCHANGE_UNKNOWN', 'folder-backup-clr'],
  ['VSS_APPLICATION', 'folder-backup-clr'],
  ['APPLICATION', 'folder-backup-clr']
]);

function getFullSvgIconName(iconName) {
  return `clr-${iconName}--32`;
}

/**
 * File icon name by archive type
 * @example <el-icon :name="'stub' | archiveIcon('NOTARIZED')"></el-icon>
 */
export default function (value, arg) {
  if (arg && arg !== '') {
    const iconName = ARCHIVE_TYPE_ICON_NAME_MAP.get(arg);
    if (iconName !== undefined && iconName !== null && iconName !== '') {
      return getFullSvgIconName(iconName);
    }
  }
  return getFullSvgIconName(UNDEFINED_ICON_NAME);
}

